const getItem = (key: any) => {
  // Check localStorage first, then sessionStorage
  return localStorage.getItem(key) || sessionStorage.getItem(key);
};

const setItem = (key: any, value: any) => {
  if (key && value) localStorage.setItem(key, value);
};

const setItemToSession = (key: any, value: any) => {
  if (key && value) sessionStorage.setItem(key, value);
};

const removeItem = (key: any) => {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
};

const clearAllLS = () => {
  localStorage.clear();
  sessionStorage.clear();
};

// App
const sidebarStatusKey = 'sidebar_status';
export const getSidebarStatus = () =>
  getItem(sidebarStatusKey);
export const setSidebarStatus = (sidebarStatus: string) =>
  setItem(sidebarStatusKey, sidebarStatus);

const languageKey = 'language';
export const getLanguage = () => getItem(languageKey);
export const setLanguage = (language: string) =>
  setItem(languageKey, language);

const sizeKey = 'size';
export const getSize = () => getItem(sizeKey);
export const setSize = (size: string) =>
  setItem(sizeKey, size);

// User
const tokenKey = 'recruit_admin_access_token';
export const getToken = () => getItem(tokenKey);
export const setToken = (token: string, rememberMe: boolean = true) => {
  if (rememberMe) {
    setItem(tokenKey, token);
  } else {
    setItemToSession(tokenKey, token);
  }
};
export const removeToken = () => removeItem(tokenKey);

export { getItem, setItem, setItemToSession, removeItem, clearAllLS };
